import React from "react";
import { Typography, Chip, Avatar, Stack } from "@mui/material";
import {
  Check as CheckIcon,
  Timer as TimerIcon,
  SkipNext as SkipIcon,
} from "@mui/icons-material";
import FiberManualRecord from "@mui/icons-material/FiberManualRecord";
import { SetProgressRow } from "./StyledComponents";

const SetDisplay = ({ set, setNumber }) => {
  // Helper function to render set details with fallbacks for undefined values
  const formatReps = () => {
    if (set.reps === undefined || set.reps === null) return "-- reps";
    if (set.reps === 1) {
      if (set.tempo) return set.tempo;
      return "Hold";
    }
    return `${set.reps} reps`;
  };

  const formatWeight = () => {
    if (set.weight === undefined || set.weight === null || set.weight <= 0)
      return null;
    return `${set.weight}kg`;
  };

  const formatRest = () => {
    if (set.rest === undefined || set.rest === null) return "Rest: --";
    return `Rest: ${set.rest}`;
  };

  const weightValue = formatWeight();
  const isSkipped = set.skipped === true;

  return (
    <SetProgressRow>
      <Avatar sx={{ width: 24, height: 24, fontSize: 12, mr: 1 }}>
        {setNumber}
      </Avatar>

      <Stack sx={{ flex: 1 }} direction="row" alignItems="center" spacing={1}>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ opacity: isSkipped ? 0.6 : 1 }}>
          {formatReps()}
        </Typography>
        {weightValue && (
          <>
            <FiberManualRecord sx={{ fontSize: 8, color: "text.secondary" }} />
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ opacity: isSkipped ? 0.6 : 1 }}>
              {weightValue}
            </Typography>
          </>
        )}
        <FiberManualRecord sx={{ fontSize: 8, color: "text.secondary" }} />
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ opacity: isSkipped ? 0.6 : 1 }}>
          {formatRest()}
        </Typography>
      </Stack>

      {isSkipped ? (
        <Chip
          icon={<SkipIcon />}
          label="Skipped"
          size="small"
          color="warning"
          variant="outlined"
        />
      ) : set.completed ? (
        <Chip
          icon={<CheckIcon />}
          label="Done"
          size="small"
          color="success"
          variant="outlined"
        />
      ) : (
        <Chip
          icon={<TimerIcon />}
          label="Pending"
          size="small"
          color="warning"
          variant="outlined"
        />
      )}
    </SetProgressRow>
  );
};

export default SetDisplay;
